/**
 * The platform console's words (admin-core.dash.ps): the platform team's own pages over every
 * workspace — reports, workspaces, modules, units, the team, the audit log and the secrets. The
 * Arabic is the approved design's (platform.html, 2026-09-26). A report's kind and status reuse
 * the feedback module's words, so a status reads the same here and in a workspace.
 */
export const CONSOLE_EN = {
    'console.title': 'Platform console',
    'console.nav.label': 'Platform console',
    'console.menu': 'Menu',
    'console.page.overview': 'Overview',
    'console.page.reports': 'Reports',
    'console.page.report': 'Report',
    'console.page.workspaces': 'Workspaces',
    'console.page.workspace': 'Workspace',
    'console.page.modules': 'Modules',
    'console.page.units': 'Units and deploys',
    'console.page.team': 'Platform team',
    'console.page.audit': 'Platform audit log',
    'console.page.secrets': 'Platform secrets',
    'console.lede.overview': 'What needs your attention now · every workspace',
    'console.lede.reports': 'Every company\'s reports, filtered by company, kind, status and age',
    'console.lede.workspaces': 'Every company: its owner, administrators and modules',
    'console.lede.modules': 'What appears in the system, and where it is on',
    'console.lede.units': 'Shown, not deployed: deploying stays on the deploy platform',
    'console.lede.team': 'Who opens the console, and in which role',
    'console.lede.audit': 'Every operation in the console: who, when, on which workspace, and why. Nothing is deleted from it.',
    'console.lede.secrets': 'Written, never shown; sealed with a key that stays on the deploy platform',
    'console.action.refresh': 'Refresh',
    'console.action.signOut': 'Sign out',
    'console.action.open': 'Open',
    'console.action.all': 'All',
    'console.action.details': 'Details',
    'console.action.close': 'Close',
    'console.action.locale': 'العربية',
    'console.action.theme': 'Appearance',
    'console.theme.light': 'Light',
    'console.theme.dark': 'Dark',
    'console.theme.system': 'As the device',
    'console.readonly': 'Your role shows this page without changing it.',
    'console.notReady.title': 'Not available yet',
    'console.notReady.detail': 'This part of the server is not deployed yet. No figure is shown until it is.',
    'console.denied.title': 'This page is for the platform owner only',
    'console.denied.detail': 'Your role in the platform team does not open it.',
    'console.refused': 'Refused: {message}',
    'console.done': 'Done.',
    'console.reason': 'Reason',
    'console.reason.hint': 'Kept in the platform audit log',
    'console.reason.required': 'Write the reason: it is kept in the platform audit log.',
    'console.signin.title': 'Platform console',
    'console.signin.email': 'Email',
    'console.signin.password': 'Password',
    'console.signin.code': 'Verification code',
    'console.signin.codeLede': 'Type the code from your authenticator application.',
    'console.signin.recovery': 'Recovery code',
    'console.signin.useRecovery': 'Use a recovery code instead',
    'console.signin.useCode': 'Use the application\'s code',
    'console.signin.submit': 'Sign in',
    'console.signin.note': 'For platform team accounts only. Company accounts do not sign in here.',
    'console.signin.enrolTitle': 'Turn on two-step sign-in',
    'console.signin.enrolLede': 'Two-step sign-in is required in the platform console. Scan the code with your authenticator application, then type the first code it shows.',
    'console.signin.qr': 'QR code for the authenticator application',
    'console.signin.enrolManual': 'Or type this key by hand',
    'console.signin.enrolConfirm': 'Turn on and sign in',
    'console.signin.back': 'Back',
    'console.signin.resuming': 'Checking the session…',
    'console.overview.date': '{date} · every workspace',
    'console.overview.workspaces': 'Workspaces',
    'console.overview.workspaces.detail': '{active} active · {suspended} suspended',
    'console.overview.active_users': 'Active users',
    'console.overview.active_users.detail': 'Last 7 days',
    'console.overview.reports': 'Open reports',
    'console.overview.reports.detail': '{n} of them older than 3 days',
    'console.overview.units': 'Units needing attention',
    'console.overview.units.none': 'All running',
    'console.overview.disk': 'Disk space',
    'console.overview.disk.detail': 'of {total} GB',
    'console.overview.latest': 'Latest reports',
    'console.overview.health': 'Units\' health',
    'console.overview.notReady': 'Not available yet',
    'console.reports.col.kind': 'Kind',
    'console.reports.col.description': 'Description',
    'console.reports.col.workspace': 'Company',
    'console.reports.col.part': 'Part',
    'console.reports.col.attachments': 'Picture / conversation',
    'console.reports.col.age': 'Since',
    'console.reports.col.status': 'Status',
    'console.reports.filter.workspace': 'Company',
    'console.reports.filter.kind': 'Kind',
    'console.reports.filter.status': 'Status',
    'console.reports.filter.age': 'Age',
    'console.reports.any': 'All',
    'console.reports.status.open': 'Open',
    'console.reports.status.all': 'Every status',
    'console.reports.age.any': 'Any age',
    'console.reports.age.day': 'Last day',
    'console.reports.age.week': 'Last week',
    'console.reports.age.older_3d': 'Older than 3 days',
    'console.reports.empty': 'No report matches these filters',
    'console.reports.picture': 'Picture',
    'console.reports.conversation': 'Conversation',
    'console.reports.count': '{n} reports',
    'console.reports.capped': 'Only the newest {n} are read: older ones are not in this list.',
    'console.report.back': 'Every report',
    'console.report.workspace': 'Company',
    'console.report.from': 'From',
    'console.report.part': 'Part',
    'console.report.page': 'Page and version',
    'console.report.browser': 'Browser',
    'console.report.language': 'Language',
    'console.report.sent': 'Sent',
    'console.report.picture': 'The picture',
    'console.report.noPicture': 'No picture was attached',
    'console.report.conversation': 'The attached conversation',
    'console.report.conversation.count': '{n} messages',
    'console.report.conversation.show': 'Show it',
    'console.report.conversation.hide': 'Hide it',
    'console.report.conversation.none': 'No conversation was attached',
    'console.report.decide': 'Reply and change the status',
    'console.report.status': 'Status',
    'console.report.reply': 'Reply',
    'console.report.replyPlaceholder': 'Write your reply to the person who sent it…',
    'console.report.save': 'Save the reply',
    'console.report.saved': 'Saved.',
    'console.report.issue': 'Open an issue on GitHub',
    'console.report.issue.lede': 'The issue is written in English from the report\'s text, part, page and version. The picture is never sent, and the conversation only if you tick it.',
    'console.report.issue.withConversation': 'Attach the conversation with the assistant',
    'console.report.issue.submit': 'Open the issue',
    'console.report.issue.opened': 'The issue was opened: {ref}',
    'console.report.pm': 'Open an issue on the project manager',
    'console.report.pm.sent': 'The report was sent to the project manager: {ref}',
    'console.report.pm.ref': 'In the project manager',
    'console.report.history': 'History',
    'console.report.history.sent': 'Sent',
    'console.report.history.status': '«{status}»',
    'console.report.history.reply': 'Replied',
    'console.report.history.note': 'A report keeps its latest status change and its latest reply, not each one before.',
    'console.workspaces.col.name': 'Workspace',
    'console.workspaces.col.owner': 'Owner',
    'console.workspaces.col.admins': 'Administrators',
    'console.workspaces.col.members': 'Members',
    'console.workspaces.col.modules': 'Modules',
    'console.workspaces.col.activity': 'Last activity',
    'console.workspaces.col.status': 'Status',
    'console.workspaces.tierRequests': '{n} tier request(s)',
    'console.workspaces.empty': 'No workspace yet',
    'console.workspaces.add': 'Add a workspace',
    'console.workspaces.add.lede': 'It opens with the modules marked for new workspaces, and the owner\'s email becomes its owner.',
    'console.workspaces.add.name': 'Company name',
    'console.workspaces.add.key': 'Key',
    'console.workspaces.add.key.help': 'Lowercase letters, digits and dashes. It appears in links and never changes.',
    'console.workspaces.add.owner_email': 'Owner\'s email',
    'console.workspaces.add.owner_name': 'Owner\'s name',
    'console.workspaces.add.owner_name.help': 'Used only when the email has no account yet.',
    'console.workspaces.add.submit': 'Create the workspace',
    'console.workspaces.created': '«{name}» was created, owned by {email}.',
    'console.workspaces.created.password': 'The email had no account, so one was made. Its first password, shown once — the owner replaces it at the first sign-in:',
    'console.workspaces.created.existing': 'The email already had an account: its owner signs in as usual and finds the new workspace.',
    'console.workspaces.created.open': 'Open the workspace page',
    'console.workspace.status.active': 'Active',
    'console.workspace.status.suspended': 'Suspended',
    'console.workspace.back': 'Every workspace',
    'console.workspace.page': 'Workspace: {name}',
    'console.workspace.owner': 'Owner',
    'console.workspace.admins': 'Administrators',
    'console.workspace.noAdmins': 'No administrator',
    'console.workspace.created': 'Created',
    'console.workspace.key': 'Key',
    'console.workspace.transfer': 'Transfer ownership',
    'console.workspace.transfer.lede': 'Ownership of {name} moves to one of its administrators.',
    'console.workspace.transfer.to': 'The new owner',
    'console.workspace.transfer.none': 'Add an administrator first: ownership moves to one of them.',
    'console.workspace.addAdmin': 'Add an administrator',
    'console.workspace.addAdmin.lede': 'An invitation link is made and shown to you once, to pass on: no email is sent.',
    'console.workspace.addAdmin.email': 'Email',
    'console.workspace.suspend': 'Suspend the workspace',
    'console.workspace.suspend.lede': 'No member of {name} signs in until it is resumed. Its data stays as it is.',
    'console.workspace.resume': 'Resume the workspace',
    'console.workspace.resume.lede': 'The members of {name} sign in again as before.',
    'console.workspace.modules': 'Modules of {name}',
    'console.workspace.units': 'Units of {name}',
    'console.workspace.unit.on': 'Turn on {unit}',
    'console.workspace.unit.off': 'Turn off {unit}',
    'console.workspace.module.alwaysOn': 'Always on',
    'console.workspace.moduleControl': 'Modules switched inside units',
    'console.workspace.moduleControl.on': 'Allow switching the modules of {unit}',
    'console.workspace.moduleControl.off': 'Stop allowing switching the modules of {unit}',
    'console.workspace.moduleControl.lede': 'For {name}, unit by unit: may its manager switch some of the unit\'s modules off? No, unless switched on here.',
    'console.workspace.tier': 'Tier of each unit',
    'console.workspace.tier.lede': 'For {name}, unit by unit: basic for a small company, standard for most, advanced for everything. Changing it only shows or hides; no data is changed or lost.',
    'console.workspace.pm': 'Reports to the project manager',
    'console.workspace.pm.lede': 'How {name}\'s reports reach the project manager. «Straight to analysis»: each new report is sent by itself after the switch. «Waiting for approval»: nothing is sent until the product team presses «Open an issue on the project manager» on the report.',
    'console.workspace.pm.mode': 'Mode',
    'console.workspace.pm.auto': 'Straight to analysis',
    'console.workspace.pm.approval': 'Waiting for approval',
    'console.workspace.tier.of': 'Tier of {unit}',
    'console.workspace.tier.basic': 'Basic',
    'console.workspace.tier.standard': 'Standard',
    'console.workspace.tier.advanced': 'Advanced',
    'console.workspace.tier.requested': 'Asked for {tier}',
    'console.workspace.tier.approve': 'Approve',
    'console.workspace.tier.reject': 'Reject the request',
    'console.workspace.tier.reject.lede': 'The administrator of {name} reads your note on the unit\'s page. The tier stays as it is.',
    'console.workspace.tier.reject.note': 'Note',
    'console.workspace.module.on': 'Turn on {module}',
    'console.workspace.module.off': 'Turn off {module}',
    'console.workspace.module.lede': 'In {name}. The reason is kept in the platform audit log.',
    'console.workspace.usage': 'Usage',
    'console.workspace.usage.members': 'Members',
    'console.workspace.usage.members.detail': '{n} administrators',
    'console.workspace.usage.active': 'Active this week',
    'console.workspace.usage.reports': 'Open reports',
    'console.workspace.usage.reports.detail': 'of {n} in all',
    'console.workspace.usage.storage': 'Storage',
    'console.workspace.usage.storage.detail': 'Files and documents',
    'console.workspace.usage.plan': 'Plan',
    'console.workspace.usage.plan.detail': 'Added later with billing',
    'console.modules.col.module': 'Module',
    'console.modules.col.unit': 'Unit',
    'console.modules.col.level': 'Level',
    'console.modules.col.enabled_in': 'On in',
    'console.modules.col.default': 'Shown to new workspaces',
    'console.modules.col.status': 'Status',
    'console.modules.enabledIn': '{n} workspaces',
    'console.modules.default.label': 'Shown to new workspaces: {module}',
    'console.module.status.available': 'Available',
    'console.module.status.experimental': 'Experimental',
    'console.module.status.not_deployed': 'Not deployed',
    'console.module.status.other': 'Unknown',
    'console.units.col.unit': 'Unit',
    'console.units.col.level': 'Level',
    'console.units.col.version': 'Deployed version',
    'console.units.col.deployed': 'Last deploy',
    'console.units.col.health': 'Health',
    'console.units.col.latency': 'Response time',
    'console.units.col.registered': 'Last registration',
    'console.units.server': 'The server',
    'console.units.disk': 'Disk space',
    'console.units.disk.value': '{pct}% of {total} GB',
    'console.units.disk.pct': '{pct}%',
    'console.units.ms': '{n} ms',
    'console.unit.health.ok': 'Running',
    'console.unit.health.down': 'Not answering',
    'console.unit.health.not_deployed': 'Not deployed',
    'console.unit.health.unknown': 'Not checked',
    'console.unit.identity': 'Identity',
    'console.unit.common': 'Common',
    'console.unit.accounting': 'Finance',
    'console.unit.hr': 'Human resources',
    'console.unit.gov-sa': 'Government bodies',
    'console.unit.assistant': 'Assistant',
    'console.unit.tags': 'Tags',
    'console.unit.platform': 'Platform',
    'console.unit.commercial': 'Customer relationships',
    'console.unit.ads': 'Ads',
    'console.unit.marketing': 'Marketing',
    'console.team.col.name': 'Name',
    'console.team.col.email': 'Email',
    'console.team.col.role': 'Role',
    'console.team.col.second_factor': 'Two-step sign-in',
    'console.team.col.last_login': 'Last sign-in',
    'console.team.sf.on': 'On',
    'console.team.sf.off': 'Not on yet',
    'console.team.you': 'You',
    'console.team.withdrawn': 'Withdrawn',
    'console.team.withdraw': 'Withdraw access',
    'console.team.withdraw.title': 'Withdraw {name}\'s access?',
    'console.team.withdraw.lede': 'They no longer open the console. Their name stays in the platform audit log.',
    'console.team.add': 'Add a member',
    'console.team.add.lede': 'A first password is made and shown to you once, to pass on. At their first sign-in they set up two-step sign-in and choose their own password.',
    'console.team.add.name': 'Name',
    'console.team.add.email': 'Email',
    'console.team.add.role': 'Role',
    'console.role.owner': 'Platform owner',
    'console.role.support': 'Support',
    'console.role.readonly': 'Read only',
    'console.role.owner.about': 'Everything, including adding team members.',
    'console.role.support.about': 'Reports and replying to them, and viewing workspaces without changing them.',
    'console.role.readonly.about': 'Sees every page and changes nothing.',
    'console.audit.col.at': 'Time',
    'console.audit.col.actor': 'Who',
    'console.audit.col.action': 'Operation',
    'console.audit.col.workspace': 'Workspace',
    'console.audit.col.reason': 'Reason',
    'console.audit.filter.workspace': 'Workspace',
    'console.audit.actor.operator': 'The operator key',
    'console.audit.empty': 'No operation yet',
    'console.secrets.col.secret': 'Secret',
    'console.secrets.col.unit': 'Unit',
    'console.secrets.col.value': 'Value',
    'console.secrets.col.set': 'Set',
    'console.secrets.col.test': 'Last test',
    'console.secrets.col.source': 'Source',
    'console.secret.source.console': 'Console',
    'console.secret.source.env': 'Deploy platform',
    'console.secret.source.unset': 'Not set',
    'console.secret.test.ok': 'Passed',
    'console.secret.test.failed': 'Failed',
    'console.secret.set': 'Set',
    'console.secret.replace': 'Replace',
    'console.secret.move': 'Move to the console',
    'console.secret.test': 'Test',
    'console.secret.withdraw': 'Withdraw',
    'console.secret.value': 'The new value',
    'console.secret.dialog.lede': 'Sealed when saved and never shown after: only its last four characters appear.',
    'console.secret.tested.ok': 'The test passed.',
    'console.secret.tested.failed': 'The test failed: {detail}',
    'console.secret.withdraw.title': 'Withdraw {name} from the console?',
    'console.secret.withdraw.lede': 'The sealed value here is erased. If it is set on the deploy platform, the system goes back to that one.',
    'console.secret.unavailable': '{unit} keeps no secrets here: PLATFORM_SECRETS_KEK is not set on it. It keeps reading them from the deploy platform.',
    'console.secrets.note.source.title': 'Source',
    'console.secrets.note.source': '«Console» means the value is sealed here and in use. «Deploy platform» means the system still reads it from there as a fallback. Once you move it to the console and confirm it, you remove it from the deploy platform yourself.',
    'console.secrets.note.stays.title': 'What stays on the deploy platform',
    'console.secrets.note.stays': 'Databases, encryption keys, the setup and emergency keys, the connection between units, and file storage.',
    'console.secrets.note.who.title': 'Who sees this page',
    'console.secrets.note.who': 'The platform owner alone. Support does not see it.',
    'console.auditMissing': 'Done, but the platform audit log did not record it (identity did not answer).',
    'console.reason.long': 'The reason is longer than 500 characters.',
    'console.signin.recoveryTitle': 'Keep your recovery codes',
    'console.signin.recoveryLede': 'These codes are shown once. Each one signs you in once if you lose your authenticator. Keep them somewhere safe.',
    'console.signin.recoveryDone': 'I kept them, continue',
    'console.password.title': 'Choose a new password',
    'console.password.lede': 'Your password is a temporary one. Choose your own (at least 8 characters), then sign in again with it.',
    'console.password.current': 'Current password',
    'console.password.next': 'New password',
    'console.password.again': 'Type it again',
    'console.password.submit': 'Change the password',
    'console.password.short': 'At least 8 characters.',
    'console.password.mismatch': 'The two do not match.',
    'console.password.changed': 'The password was changed. Sign in with it again.',
    'console.report.byPlatform': 'The platform team',
    'console.report.issue.view': 'The issue on GitHub',
    'console.workspace.invite.made': 'The invitation link, shown once — valid until {date}:',
    'console.team.added': '{email} was added. Their first password, shown once:',
    'console.units.col.uptime': 'Running since',
    'console.audit.filter.action': 'Operation',
    'console.audit.older': 'Older operations',
    'console.secret.edit': 'Edit',
    'console.secret.dialog.setting': 'A setting, not a key: its value is shown.',
    'platform.refusal.role': 'Your role does not allow this.',
    'platform.refusal.wrong_credentials': 'The email or the password is not right.',
    'platform.refusal.withdrawn': 'This account\'s access to the console was withdrawn.',
    'platform.refusal.too_many_attempts': 'Too many attempts. Wait a little and try again.',
    'platform.refusal.second_factor_unavailable': 'Signing in is not possible: two-step sign-in is not set up on this installation (SECOND_FACTOR_KEK).',
    'platform.refusal.wrong_code': 'The code is not right.',
    'platform.refusal.locked': 'Too many wrong codes. Wait 15 minutes.',
    'platform.refusal.challenge_expired': 'The second step took too long. Sign in again.',
    'platform.refusal.must_change_password': 'Choose a new password first.',
    'platform.refusal.no_session': 'The session ended. Sign in again.',
    'platform.refusal.session_replaced': 'This session was used elsewhere and ended. Sign in again.',
    'platform.refusal.workspace_not_found': 'There is no such workspace.',
    'platform.refusal.already_member': 'This email is already a member of the workspace.',
    'platform.refusal.key_taken': 'This key is taken by another workspace. Choose another.',
    'platform.refusal.key_invalid': 'The key is 2 to 40 lowercase letters, digits and dashes, starting with a letter.',
    'platform.refusal.name_invalid': 'Enter the company name, up to 120 characters.',
    'platform.refusal.email_invalid': 'Enter a valid email address.',
    'platform.refusal.owner_suspended': 'This email belongs to a suspended account. Choose another owner.',
    'platform.refusal.own_account': 'Nobody withdraws their own access.',
    'platform.refusal.last_owner': 'The last platform owner cannot be withdrawn.',
    'platform.refusal.already_filed': 'An issue was already opened for this report.',
    'platform.refusal.not_filed': 'This report has no issue on GitHub yet.',
    'console.report.issue.priority': 'Priority',
    'console.report.issue.priority.low': 'Low',
    'console.report.issue.priority.medium': 'Medium',
    'console.report.issue.priority.high': 'High',
    'console.report.issue.priority.critical': 'Critical',
    'console.report.issue.check': 'Check its state on GitHub',
    'console.report.issue.check.open': 'The issue is still open on GitHub. Nothing changed.',
    'console.report.issue.check.resolved': 'The issue is closed on GitHub, so the report is now resolved and its sender is told.',
    'console.report.issue.check.closed': 'The issue is closed on GitHub. The report was already decided, so it stays as it is.',
    'platform.refusal.github_not_configured': 'The GitHub key is not set: set it in the platform secrets.',
    'platform.refusal.value_invalid': 'This value is not accepted for this setting. The GitHub repository is written owner/name, like erp-sslab/core.',
    'platform.refusal.value_required': 'Enter a value.',
    'platform.refusal.secrets_unavailable': 'This unit cannot keep settings: PLATFORM_SECRETS_KEK is not set on it.',
    'platform.refusal.github_refused': 'GitHub refused the issue.',
    'platform.refusal.pm_not_configured': 'The project manager\'s address and key are not set: set them in the platform secrets.',
    'platform.refusal.already_in_pm': 'This report is in the project manager already: no second task is opened.',
    'platform.refusal.pm_refused': 'The project manager did not take the report, or could not be reached. An automatic send is tried again.',
    'feedback.refusal.mode': 'The mode is either «straight to analysis» or «waiting for approval».',
    'feedback.refusal.tenant_id': 'Not a valid workspace id.',
    'platform.refusal.not_testable': 'This setting has no test.',
    'platform.action.platform.bootstrap': 'Created the first platform owner',
    'platform.action.team.added': 'Added a team member',
    'platform.action.team.withdrawn': 'Withdrew a team member',
    'platform.action.auth.password_changed': 'Changed their password',
    'platform.action.workspace.suspended': 'Suspended the workspace',
    'platform.action.workspace.resumed': 'Resumed the workspace',
    'platform.action.workspace.ownership_transferred': 'Transferred ownership',
    'platform.action.workspace.admin_invited': 'Invited an administrator',
    'platform.action.workspace.module_enabled': 'Turned a module on',
    'platform.action.workspace.unit_enabled': 'Turned a unit on',
    'platform.action.workspace.unit_disabled': 'Turned a unit off',
    'platform.action.workspace.module_control': 'Changed who switches a unit\'s modules',
    'platform.action.workspace.unit_tier': 'Changed a unit\'s tier',
    'platform.action.workspace.tier_request_approved': 'Approved a tier request',
    'platform.action.workspace.tier_request_rejected': 'Rejected a tier request',
    'platform.action.workspace.module_disabled': 'Turned a module off',
    'platform.action.module.default_changed': 'Changed a module for new workspaces',
    'platform.action.feedback.status_changed': 'Changed a report\'s status',
    'platform.action.feedback.github_issue': 'Opened an issue on GitHub',
    'platform.action.feedback.pm_task': 'Opened an issue on the project manager',
    'platform.action.feedback.pm_policy_changed': 'Changed how reports reach the project manager',
    'platform.action.secret.set': 'Set a secret',
    'platform.action.secret.tested': 'Tested a secret',
    'platform.action.secret.withdrawn': 'Withdrew a secret',
    'console.secret.name.LLM_API_KEY': 'Language model key',
    'console.secret.name.LLM_PROVIDER': 'Language model provider',
    'console.secret.name.LLM_MODEL': 'Language model',
    'console.secret.name.LLM_BASE_URL': 'Provider address',
    'console.secret.name.NOTIFY_EMAIL_PROVIDER': 'Default mail: how it is sent',
    'console.secret.name.NOTIFY_SMTP_HOST': 'Default mail (SMTP): server',
    'console.secret.name.NOTIFY_SMTP_PORT': 'Default mail (SMTP): port',
    'console.secret.name.NOTIFY_SMTP_USER': 'Default mail (SMTP): user',
    'console.secret.name.NOTIFY_SMTP_PASSWORD': 'Default mail (SMTP): password',
    'console.secret.name.NOTIFY_EMAIL_FROM': 'Default mail: sender',
    'console.secret.name.NOTIFY_EMAIL_HTTP_URL': 'Default mail (HTTP): address',
    'console.secret.name.NOTIFY_EMAIL_HTTP_TOKEN': 'Default mail (HTTP): key',
    'console.secret.name.NOTIFY_WHATSAPP_PROVIDER': 'Platform WhatsApp: provider',
    'console.secret.name.NOTIFY_WHATSAPP_PHONE_NUMBER_ID': 'Platform WhatsApp: number',
    'console.secret.name.NOTIFY_WHATSAPP_ACCESS_TOKEN': 'Platform WhatsApp: access key',
    'console.secret.name.NOTIFY_WHATSAPP_APP_SECRET': 'Platform WhatsApp: app secret',
    'console.secret.name.NOTIFY_WHATSAPP_VERIFY_TOKEN': 'Platform WhatsApp: verification key',
    'console.secret.name.NOTIFY_SMS_PROVIDER': 'Default text messages: provider',
    'console.secret.name.NOTIFY_SMS_TOKEN': 'Default text messages: key',
    'console.secret.name.NOTIFY_SMS_SENDER': 'Default text messages: sender',
    'console.secret.name.NOTIFY_PUSH_PROVIDER': 'Push to the employee app: provider',
    'console.secret.name.NOTIFY_PUSH_FCM_PROJECT_ID': 'Push to the employee app: Firebase project',
    'console.secret.name.NOTIFY_PUSH_FCM_CLIENT_EMAIL': 'Push to the employee app: service account',
    'console.secret.name.NOTIFY_PUSH_FCM_PRIVATE_KEY': 'Push to the employee app: service account key',
    'console.secret.name.FEEDBACK_OPERATOR_EMAIL': 'Product team email',
    'console.secret.name.GITHUB_TOKEN': 'GitHub key',
    'console.secret.name.GITHUB_REPO': 'GitHub repository',
    'console.secret.name.PM_URL': 'Project manager (pm) address',
    'console.secret.name.PM_TOKEN': 'Project manager (pm) key',
};
export const CONSOLE_AR = {
    'console.title': 'لوحة المنصة',
    'console.nav.label': 'لوحة المنصة',
    'console.menu': 'القائمة',
    'console.page.overview': 'النظرة العامة',
    'console.page.reports': 'البلاغات',
    'console.page.report': 'البلاغ',
    'console.page.workspaces': 'مساحات العمل',
    'console.page.workspace': 'مساحة العمل',
    'console.page.modules': 'المديولات',
    'console.page.units': 'الوحدات والنشر',
    'console.page.team': 'فريق المنصة',
    'console.page.audit': 'سجل عمليات المنصة',
    'console.page.secrets': 'أسرار المنصة',
    'console.lede.overview': 'ما يحتاج انتباهك الآن · كل المساحات',
    'console.lede.reports': 'بلاغات كل الشركات، بتصفية حسب الشركة والنوع والحالة والعمر',
    'console.lede.workspaces': 'كل شركة، مالكها ومسؤولوها ومديولاتها',
    'console.lede.modules': 'ما يظهر في النظام، وأين هو مفعّل',
    'console.lede.units': 'تعرض ولا تنشر: النشر نفسه يبقى من منصة النشر',
    'console.lede.team': 'من يدخل اللوحة وبأي دور',
    'console.lede.audit': 'كل عملية في اللوحة: من، ومتى، وعلى أي مساحة، ولماذا. لا يُحذف منه شيء.',
    'console.lede.secrets': 'تُكتب ولا تُعرض، مشفّرة بمفتاح يبقى في منصة النشر',
    'console.action.refresh': 'تحديث',
    'console.action.signOut': 'اخرج',
    'console.action.open': 'افتح',
    'console.action.all': 'الكل',
    'console.action.details': 'التفاصيل',
    'console.action.close': 'أغلق',
    'console.action.locale': 'English',
    'console.action.theme': 'المظهر',
    'console.theme.light': 'فاتح',
    'console.theme.dark': 'داكن',
    'console.theme.system': 'كما في الجهاز',
    'console.readonly': 'دورك يعرض هذه الصفحة دون تعديلها.',
    'console.notReady.title': 'غير متاح بعد',
    'console.notReady.detail': 'لم يُنشر هذا الجزء من الخادم بعد. لا يُعرض رقم حتى يصل.',
    'console.denied.title': 'هذه الصفحة لمالك المنصة وحده',
    'console.denied.detail': 'دورك في فريق المنصة لا يفتحها.',
    'console.refused': 'رُفض: {message}',
    'console.done': 'تم.',
    'console.reason': 'السبب',
    'console.reason.hint': 'يُحفظ في سجل عمليات المنصة',
    'console.reason.required': 'اكتب السبب: يُحفظ في سجل عمليات المنصة.',
    'console.signin.title': 'لوحة المنصة',
    'console.signin.email': 'البريد',
    'console.signin.password': 'كلمة المرور',
    'console.signin.code': 'رمز التحقق',
    'console.signin.codeLede': 'اكتب الرمز من تطبيق التحقق.',
    'console.signin.recovery': 'رمز الاسترداد',
    'console.signin.useRecovery': 'استعمل رمز استرداد بدلاً منه',
    'console.signin.useCode': 'استعمل رمز التطبيق',
    'console.signin.submit': 'ادخل',
    'console.signin.note': 'لحسابات فريق المنصة فقط. حسابات الشركات لا تدخل من هنا.',
    'console.signin.enrolTitle': 'فعّل التحقق بخطوتين',
    'console.signin.enrolLede': 'التحقق بخطوتين إلزامي في لوحة المنصة. امسح الرمز بتطبيق التحقق، ثم اكتب أول رمز يظهر فيه.',
    'console.signin.qr': 'رمز QR لتطبيق التحقق',
    'console.signin.enrolManual': 'أو اكتب هذا المفتاح يدوياً',
    'console.signin.enrolConfirm': 'فعّل وادخل',
    'console.signin.back': 'رجوع',
    'console.signin.resuming': 'جارٍ التحقق من الجلسة…',
    'console.overview.date': '{date} · كل المساحات',
    'console.overview.workspaces': 'مساحات العمل',
    'console.overview.workspaces.detail': '{active} نشطة · {suspended} معلّقة',
    'console.overview.active_users': 'المستخدمون النشطون',
    'console.overview.active_users.detail': 'آخر 7 أيام',
    'console.overview.reports': 'بلاغات مفتوحة',
    'console.overview.reports.detail': '{n} منها أكثر من 3 أيام',
    'console.overview.units': 'وحدات تحتاج انتباهاً',
    'console.overview.units.none': 'كلها تعمل',
    'console.overview.disk': 'مساحة القرص',
    'console.overview.disk.detail': 'من {total} GB',
    'console.overview.latest': 'أحدث البلاغات',
    'console.overview.health': 'صحة الوحدات',
    'console.overview.notReady': 'غير متاح بعد',
    'console.reports.col.kind': 'النوع',
    'console.reports.col.description': 'الوصف',
    'console.reports.col.workspace': 'الشركة',
    'console.reports.col.part': 'الجزء',
    'console.reports.col.attachments': 'صورة/محادثة',
    'console.reports.col.age': 'منذ',
    'console.reports.col.status': 'الحالة',
    'console.reports.filter.workspace': 'الشركة',
    'console.reports.filter.kind': 'النوع',
    'console.reports.filter.status': 'الحالة',
    'console.reports.filter.age': 'العمر',
    'console.reports.any': 'الكل',
    'console.reports.status.open': 'المفتوحة',
    'console.reports.status.all': 'كل الحالات',
    'console.reports.age.any': 'أي عمر',
    'console.reports.age.day': 'آخر يوم',
    'console.reports.age.week': 'آخر أسبوع',
    'console.reports.age.older_3d': 'أكثر من 3 أيام',
    'console.reports.empty': 'لا بلاغ بهذه التصفية',
    'console.reports.picture': 'صورة',
    'console.reports.conversation': 'محادثة',
    'console.reports.count': '{n} بلاغ',
    'console.reports.capped': 'تُقرأ أحدث {n} فقط: الأقدم منها ليست في هذه القائمة.',
    'console.report.back': 'كل البلاغات',
    'console.report.workspace': 'الشركة',
    'console.report.from': 'من',
    'console.report.part': 'الجزء',
    'console.report.page': 'الصفحة والنسخة',
    'console.report.browser': 'المتصفح',
    'console.report.language': 'اللغة',
    'console.report.sent': 'أُرسل',
    'console.report.picture': 'الصورة',
    'console.report.noPicture': 'لم تُرفق صورة',
    'console.report.conversation': 'المحادثة المرفقة',
    'console.report.conversation.count': '{n} رسائل',
    'console.report.conversation.show': 'اعرضها',
    'console.report.conversation.hide': 'أخفها',
    'console.report.conversation.none': 'لم تُرفق محادثة',
    'console.report.decide': 'الرد وتغيير الحالة',
    'console.report.status': 'الحالة',
    'console.report.reply': 'الرد',
    'console.report.replyPlaceholder': 'اكتب ردّك لصاحب البلاغ…',
    'console.report.save': 'احفظ الرد',
    'console.report.saved': 'حُفظ.',
    'console.report.issue': 'افتح قضية على جيت هاب',
    'console.report.issue.lede': 'تُكتب القضية بالإنجليزية من نص البلاغ وجزئه وصفحته ونسخته. لا تُرسل الصورة أبداً، ولا المحادثة إلا إن اخترتها.',
    'console.report.issue.withConversation': 'أرفق المحادثة مع المساعد',
    'console.report.issue.submit': 'افتح القضية',
    'console.report.issue.opened': 'فُتحت القضية: {ref}',
    'console.report.pm': 'افتح قضية على مدير المشاريع',
    'console.report.pm.sent': 'أُرسل البلاغ إلى مدير المشاريع: {ref}',
    'console.report.pm.ref': 'في مدير المشاريع',
    'console.report.history': 'السجل',
    'console.report.history.sent': 'أُرسل',
    'console.report.history.status': '«{status}»',
    'console.report.history.reply': 'رُدّ عليه',
    'console.report.history.note': 'يحفظ البلاغ آخر تغيير لحالته وآخر رد عليه، لا كل ما قبلهما.',
    'console.workspaces.col.name': 'المساحة',
    'console.workspaces.col.owner': 'المالك',
    'console.workspaces.col.admins': 'المسؤولون',
    'console.workspaces.col.members': 'الأعضاء',
    'console.workspaces.col.modules': 'المديولات',
    'console.workspaces.col.activity': 'آخر نشاط',
    'console.workspaces.col.status': 'الحالة',
    'console.workspaces.tierRequests': 'طلبات مستوى: {n}',
    'console.workspaces.empty': 'لا مساحة عمل بعد',
    'console.workspaces.add': 'أضف مساحة عمل',
    'console.workspaces.add.lede': 'تُفتح بالمديولات المعلَّمة «للمساحات الجديدة»، ويصبح صاحب البريد مالكها.',
    'console.workspaces.add.name': 'اسم الشركة',
    'console.workspaces.add.key': 'المعرّف',
    'console.workspaces.add.key.help': 'أحرف إنجليزية صغيرة وأرقام وشرطات. يظهر في الروابط ولا يتغيّر.',
    'console.workspaces.add.owner_email': 'بريد المالك',
    'console.workspaces.add.owner_name': 'اسم المالك',
    'console.workspaces.add.owner_name.help': 'يُستعمل فقط إن لم يكن للبريد حساب بعد.',
    'console.workspaces.add.submit': 'أنشئ المساحة',
    'console.workspaces.created': 'أُنشئت «{name}»، ومالكها {email}.',
    'console.workspaces.created.password': 'البريد لم يكن له حساب، فأُنشئ حساب بكلمة مرور مؤقتة. تظهر هذه المرة فقط، ويغيّرها المالك عند أول دخول:',
    'console.workspaces.created.existing': 'للبريد حساب قائم: يدخل صاحبه كالمعتاد ويجد المساحة الجديدة.',
    'console.workspaces.created.open': 'افتح صفحة المساحة',
    'console.workspace.status.active': 'نشطة',
    'console.workspace.status.suspended': 'معلّقة',
    'console.workspace.back': 'كل المساحات',
    'console.workspace.page': 'صفحة المساحة: {name}',
    'console.workspace.owner': 'المالك',
    'console.workspace.admins': 'المسؤولون',
    'console.workspace.noAdmins': 'لا مسؤول',
    'console.workspace.created': 'أُنشئت',
    'console.workspace.key': 'المفتاح',
    'console.workspace.transfer': 'نقل الملكية',
    'console.workspace.transfer.lede': 'تنتقل ملكية {name} إلى أحد مسؤوليها.',
    'console.workspace.transfer.to': 'المالك الجديد',
    'console.workspace.transfer.none': 'أضف مسؤولاً أولاً: تنتقل الملكية إلى أحد المسؤولين.',
    'console.workspace.addAdmin': 'أضف مسؤولاً',
    'console.workspace.addAdmin.lede': 'يُنشأ رابط دعوة يظهر لك مرة واحدة لتسلّمه له: لا يُرسل بريد.',
    'console.workspace.addAdmin.email': 'البريد',
    'console.workspace.suspend': 'علّق المساحة',
    'console.workspace.suspend.lede': 'لا يدخل أحد من أعضاء {name} حتى تُستأنف. تبقى بياناتها كما هي.',
    'console.workspace.resume': 'استأنف المساحة',
    'console.workspace.resume.lede': 'يعود أعضاء {name} إلى الدخول كما كانوا.',
    'console.workspace.modules': 'مديولات {name}',
    'console.workspace.units': 'وحدات {name}',
    'console.workspace.unit.on': 'فعّل {unit}',
    'console.workspace.unit.off': 'أوقف {unit}',
    'console.workspace.module.alwaysOn': 'أساسي دائماً',
    'console.workspace.moduleControl': 'التحكم في مديولات الوحدات',
    'console.workspace.moduleControl.on': 'السماح بإيقاف مديولات {unit}',
    'console.workspace.moduleControl.off': 'إلغاء السماح بإيقاف مديولات {unit}',
    'console.workspace.moduleControl.lede': 'لـ {name}، وحدة وحدة: هل يستطيع مديرها إيقاف بعض مديولات الوحدة؟ لا، ما لم يُفعَّل هنا.',
    'console.workspace.tier': 'مستوى كل وحدة',
    'console.workspace.tier.lede': 'لـ {name}، وحدة وحدة: الأساسي للشركات الصغيرة، والمتوسط لأغلب الشركات، والمتقدم لكل المميزات. تغيير المستوى يُظهر ويُخفي فقط، ولا تتغير أي بيانات ولا تُفقد.',
    'console.workspace.pm': 'نقل البلاغات إلى مدير المشاريع',
    'console.workspace.pm.lede': 'كيف تصل بلاغات {name} إلى مدير المشاريع. «مباشرة إلى التحليل»: يُرسل كل بلاغ جديد تلقائياً بعد التفعيل. «بانتظار الموافقة»: لا يُرسل شيء حتى يضغط فريق المنتج «افتح قضية على مدير المشاريع» في صفحة البلاغ.',
    'console.workspace.pm.mode': 'وضع النقل',
    'console.workspace.pm.auto': 'مباشرة إلى التحليل',
    'console.workspace.pm.approval': 'بانتظار الموافقة',
    'console.workspace.tier.of': 'مستوى {unit}',
    'console.workspace.tier.basic': 'أساسي',
    'console.workspace.tier.standard': 'متوسط',
    'console.workspace.tier.advanced': 'متقدم',
    'console.workspace.tier.requested': 'طلبت الشركة: {tier}',
    'console.workspace.tier.approve': 'موافقة',
    'console.workspace.tier.reject': 'رفض الطلب',
    'console.workspace.tier.reject.lede': 'يقرأ مدير {name} ملاحظتك في صفحة الوحدة، ويبقى المستوى كما هو.',
    'console.workspace.tier.reject.note': 'ملاحظة',
    'console.workspace.module.on': 'فعّل {module}',
    'console.workspace.module.off': 'أوقف {module}',
    'console.workspace.module.lede': 'في {name}. يُحفظ السبب في سجل عمليات المنصة.',
    'console.workspace.usage': 'الاستعمال',
    'console.workspace.usage.members': 'الأعضاء',
    'console.workspace.usage.members.detail': '{n} مسؤولون',
    'console.workspace.usage.active': 'النشطون هذا الأسبوع',
    'console.workspace.usage.reports': 'بلاغات مفتوحة',
    'console.workspace.usage.reports.detail': 'من {n} إجمالاً',
    'console.workspace.usage.storage': 'التخزين',
    'console.workspace.usage.storage.detail': 'ملفات ووثائق',
    'console.workspace.usage.plan': 'الخطة',
    'console.workspace.usage.plan.detail': 'تُضاف لاحقاً مع الفوترة',
    'console.modules.col.module': 'المديول',
    'console.modules.col.unit': 'الوحدة',
    'console.modules.col.level': 'المستوى',
    'console.modules.col.enabled_in': 'مفعّل في',
    'console.modules.col.default': 'يظهر للمساحات الجديدة',
    'console.modules.col.status': 'الحالة',
    'console.modules.enabledIn': '{n} مساحة',
    'console.modules.default.label': 'يظهر للمساحات الجديدة: {module}',
    'console.module.status.available': 'متاح',
    'console.module.status.experimental': 'تجريبي',
    'console.module.status.not_deployed': 'غير منشور',
    'console.module.status.other': 'غير معروف',
    'console.units.col.unit': 'الوحدة',
    'console.units.col.level': 'المستوى',
    'console.units.col.version': 'النسخة المنشورة',
    'console.units.col.deployed': 'آخر نشر',
    'console.units.col.health': 'الصحة',
    'console.units.col.latency': 'زمن الاستجابة',
    'console.units.col.registered': 'آخر تسجيل',
    'console.units.server': 'الخادم',
    'console.units.disk': 'مساحة القرص',
    'console.units.disk.value': '{pct}% من {total} GB',
    'console.units.disk.pct': '{pct}%',
    'console.units.ms': '{n} ms',
    'console.unit.health.ok': 'تعمل',
    'console.unit.health.down': 'لا تستجيب',
    'console.unit.health.not_deployed': 'غير منشورة',
    'console.unit.health.unknown': 'لم تُفحص',
    'console.unit.identity': 'الهوية',
    'console.unit.common': 'المشترك',
    'console.unit.accounting': 'المالية',
    'console.unit.hr': 'الموارد البشرية',
    'console.unit.gov-sa': 'الجهات الحكومية',
    'console.unit.assistant': 'المساعد',
    'console.unit.tags': 'الوسوم',
    'console.unit.platform': 'المنصة',
    'console.unit.commercial': 'علاقات العملاء',
    'console.unit.ads': 'الإعلانات',
    'console.unit.marketing': 'التسويق',
    'console.team.col.name': 'الاسم',
    'console.team.col.email': 'البريد',
    'console.team.col.role': 'الدور',
    'console.team.col.second_factor': 'التحقق بخطوتين',
    'console.team.col.last_login': 'آخر دخول',
    'console.team.sf.on': 'مفعّل',
    'console.team.sf.off': 'لم يُفعَّل بعد',
    'console.team.you': 'أنت',
    'console.team.withdrawn': 'مسحوب',
    'console.team.withdraw': 'اسحب الوصول',
    'console.team.withdraw.title': 'تسحب وصول {name}؟',
    'console.team.withdraw.lede': 'لن يدخل اللوحة بعد الآن. يبقى اسمه في سجل عمليات المنصة.',
    'console.team.add': 'أضف عضواً',
    'console.team.add.lede': 'تُنشأ كلمة مرور أولى تظهر لك مرة واحدة لتسلّمها له. عند أول دخول يفعّل التحقق بخطوتين ويختار كلمة مروره.',
    'console.team.add.name': 'الاسم',
    'console.team.add.email': 'البريد',
    'console.team.add.role': 'الدور',
    'console.role.owner': 'مالك المنصة',
    'console.role.support': 'دعم',
    'console.role.readonly': 'قراءة فقط',
    'console.role.owner.about': 'كل شيء، ومنه إضافة أعضاء الفريق.',
    'console.role.support.about': 'البلاغات والرد عليها، وعرض المساحات دون تعديلها.',
    'console.role.readonly.about': 'يرى كل الصفحات ولا يغيّر شيئاً.',
    'console.audit.col.at': 'الوقت',
    'console.audit.col.actor': 'من',
    'console.audit.col.action': 'العملية',
    'console.audit.col.workspace': 'المساحة',
    'console.audit.col.reason': 'السبب',
    'console.audit.filter.workspace': 'المساحة',
    'console.audit.actor.operator': 'مفتاح المشغّل',
    'console.audit.empty': 'لا عملية بعد',
    'console.secrets.col.secret': 'السر',
    'console.secrets.col.unit': 'الوحدة',
    'console.secrets.col.value': 'القيمة',
    'console.secrets.col.set': 'ضُبط',
    'console.secrets.col.test': 'آخر اختبار',
    'console.secrets.col.source': 'المصدر',
    'console.secret.source.console': 'اللوحة',
    'console.secret.source.env': 'منصة النشر',
    'console.secret.source.unset': 'غير مضبوط',
    'console.secret.test.ok': 'ناجح',
    'console.secret.test.failed': 'فشل',
    'console.secret.set': 'اضبط',
    'console.secret.replace': 'استبدل',
    'console.secret.move': 'انقل إلى اللوحة',
    'console.secret.test': 'اختبر',
    'console.secret.withdraw': 'اسحب',
    'console.secret.value': 'القيمة الجديدة',
    'console.secret.dialog.lede': 'تُشفَّر عند الحفظ ولا تُعرض بعده: تظهر آخر أربعة أحرف منها فقط.',
    'console.secret.tested.ok': 'نجح الاختبار.',
    'console.secret.tested.failed': 'فشل الاختبار: {detail}',
    'console.secret.withdraw.title': 'تسحب {name} من اللوحة؟',
    'console.secret.withdraw.lede': 'تُمحى القيمة المشفّرة هنا. إن كانت مضبوطة في منصة النشر يعود النظام إليها.',
    'console.secret.unavailable': 'وحدة {unit} لا تحفظ أسراراً هنا: PLATFORM_SECRETS_KEK غير مضبوط فيها. تبقى تقرؤها من منصة النشر.',
    'console.secrets.note.source.title': 'المصدر',
    'console.secrets.note.source': '«اللوحة» يعني أن القيمة مشفّرة هنا وتُستعمل. «منصة النشر» يعني أن النظام ما زال يقرؤها من هناك احتياطاً. حين تنقلها إلى اللوحة وتتأكد، تحذفها أنت من منصة النشر.',
    'console.secrets.note.stays.title': 'ما يبقى في منصة النشر',
    'console.secrets.note.stays': 'قواعد البيانات، ومفاتيح التشفير، ومفاتيح التأسيس والطوارئ، والاتصال بين الوحدات، وتخزين الملفات.',
    'console.secrets.note.who.title': 'من يرى هذه الصفحة',
    'console.secrets.note.who': 'مالك المنصة وحده. فريق الدعم لا يراها.',
    'console.auditMissing': 'تمّت، لكن سجل عمليات المنصة لم يسجّلها (الهوية لم تُجب).',
    'console.reason.long': 'السبب أطول من 500 حرف.',
    'console.signin.recoveryTitle': 'احفظ رموز الاسترداد',
    'console.signin.recoveryLede': 'تظهر هذه الرموز مرة واحدة. كل رمز يُدخلك مرة واحدة إن فقدت تطبيق التحقق. احفظها في مكان آمن.',
    'console.signin.recoveryDone': 'حفظتها، تابع',
    'console.password.title': 'اختر كلمة مرور جديدة',
    'console.password.lede': 'كلمة مرورك مؤقتة. اختر كلمتك (8 أحرف على الأقل)، ثم ادخل بها من جديد.',
    'console.password.current': 'كلمة المرور الحالية',
    'console.password.next': 'كلمة المرور الجديدة',
    'console.password.again': 'اكتبها مرة أخرى',
    'console.password.submit': 'غيّر كلمة المرور',
    'console.password.short': '8 أحرف على الأقل.',
    'console.password.mismatch': 'الكلمتان غير متطابقتين.',
    'console.password.changed': 'غُيّرت كلمة المرور. ادخل بها من جديد.',
    'console.report.byPlatform': 'فريق المنصة',
    'console.report.issue.view': 'القضية على جيت هاب',
    'console.workspace.invite.made': 'رابط الدعوة، يظهر مرة واحدة — صالح حتى {date}:',
    'console.team.added': 'أُضيف {email}. كلمة مروره الأولى، تظهر مرة واحدة:',
    'console.units.col.uptime': 'يعمل منذ',
    'console.audit.filter.action': 'العملية',
    'console.audit.older': 'عمليات أقدم',
    'console.secret.edit': 'عدّل',
    'console.secret.dialog.setting': 'إعداد وليس مفتاحاً: تظهر قيمته.',
    'platform.refusal.role': 'دورك لا يسمح بهذا.',
    'platform.refusal.wrong_credentials': 'البريد أو كلمة المرور غير صحيحة.',
    'platform.refusal.withdrawn': 'سُحب وصول هذا الحساب إلى اللوحة.',
    'platform.refusal.too_many_attempts': 'محاولات كثيرة. انتظر قليلاً ثم حاول من جديد.',
    'platform.refusal.second_factor_unavailable': 'لا يمكن الدخول: التحقق بخطوتين غير مهيّأ في هذا التثبيت (SECOND_FACTOR_KEK).',
    'platform.refusal.wrong_code': 'الرمز غير صحيح.',
    'platform.refusal.locked': 'رموز خاطئة كثيرة. انتظر 15 دقيقة.',
    'platform.refusal.challenge_expired': 'تأخّرت الخطوة الثانية أكثر من اللازم. ادخل من جديد.',
    'platform.refusal.must_change_password': 'اختر كلمة مرور جديدة أولاً.',
    'platform.refusal.no_session': 'انتهت الجلسة. ادخل من جديد.',
    'platform.refusal.session_replaced': 'استُعملت هذه الجلسة في مكان آخر فانتهت. ادخل من جديد.',
    'platform.refusal.workspace_not_found': 'لا مساحة عمل بهذا المعرّف.',
    'platform.refusal.already_member': 'هذا البريد عضو في المساحة من قبل.',
    'platform.refusal.key_taken': 'هذا المعرّف مستعمل لمساحة أخرى. اختر غيره.',
    'platform.refusal.key_invalid': 'المعرّف من 2 إلى 40 حرفاً: أحرف إنجليزية صغيرة وأرقام وشرطات، ويبدأ بحرف.',
    'platform.refusal.name_invalid': 'اكتب اسم الشركة، حتى 120 حرفاً.',
    'platform.refusal.email_invalid': 'اكتب بريداً صحيحاً.',
    'platform.refusal.owner_suspended': 'هذا البريد لحساب معلّق. اختر مالكاً آخر.',
    'platform.refusal.own_account': 'لا يسحب أحد وصول نفسه.',
    'platform.refusal.last_owner': 'لا يُسحب وصول آخر مالك للمنصة.',
    'platform.refusal.already_filed': 'فُتحت قضية لهذا البلاغ من قبل.',
    'platform.refusal.not_filed': 'لا قضية لهذا البلاغ على جيت هاب بعد.',
    'console.report.issue.priority': 'الأهمية',
    'console.report.issue.priority.low': 'منخفضة',
    'console.report.issue.priority.medium': 'متوسطة',
    'console.report.issue.priority.high': 'عالية',
    'console.report.issue.priority.critical': 'حرجة',
    'console.report.issue.check': 'راجع حالتها على جيت هاب',
    'console.report.issue.check.open': 'القضية ما زالت مفتوحة على جيت هاب. لم يتغيّر شيء.',
    'console.report.issue.check.resolved': 'القضية مغلقة على جيت هاب، فصار البلاغ «حُلّت» وأُبلغ صاحبه.',
    'console.report.issue.check.closed': 'القضية مغلقة على جيت هاب، والبلاغ محسوم من قبل فبقي كما هو.',
    'platform.refusal.github_not_configured': 'مفتاح جيت هاب غير مضبوط: اضبطه في أسرار المنصة.',
    'platform.refusal.value_invalid': 'هذه القيمة غير مقبولة لهذا الإعداد. مستودع جيت هاب يُكتب بصيغة المالك/الاسم، مثل erp-sslab/core.',
    'platform.refusal.value_required': 'اكتب قيمة.',
    'platform.refusal.secrets_unavailable': 'هذه الوحدة لا تحفظ إعدادات: PLATFORM_SECRETS_KEK غير مضبوط فيها.',
    'platform.refusal.github_refused': 'رفض جيت هاب إنشاء القضية.',
    'platform.refusal.pm_not_configured': 'عنوان مدير المشاريع ومفتاحه غير مضبوطين: اضبطهما في أسرار المنصة.',
    'platform.refusal.already_in_pm': 'هذا البلاغ موجود في مدير المشاريع من قبل، ولا تُفتح له مهمة ثانية.',
    'platform.refusal.pm_refused': 'لم يقبل مدير المشاريع البلاغ أو تعذّر الوصول إليه. إن كان النقل تلقائياً فستُعاد المحاولة.',
    'feedback.refusal.mode': 'الوضع إما «مباشرة إلى التحليل» أو «بانتظار الموافقة».',
    'feedback.refusal.tenant_id': 'معرّف المساحة غير صالح.',
    'platform.refusal.not_testable': 'لا اختبار لهذا الإعداد.',
    'platform.action.platform.bootstrap': 'أُنشئ مالك المنصة الأول',
    'platform.action.team.added': 'أضاف عضواً إلى الفريق',
    'platform.action.team.withdrawn': 'سحب وصول عضو',
    'platform.action.auth.password_changed': 'غيّر كلمة مروره',
    'platform.action.workspace.suspended': 'علّق المساحة',
    'platform.action.workspace.resumed': 'استأنف المساحة',
    'platform.action.workspace.ownership_transferred': 'نقل الملكية',
    'platform.action.workspace.admin_invited': 'دعا مسؤولاً',
    'platform.action.workspace.module_enabled': 'فعّل مديولاً',
    'platform.action.workspace.unit_enabled': 'فعّل وحدة',
    'platform.action.workspace.unit_disabled': 'أوقف وحدة',
    'platform.action.workspace.module_control': 'غيّر السماح بإيقاف مديولات وحدة',
    'platform.action.workspace.unit_tier': 'غيّر مستوى وحدة',
    'platform.action.workspace.tier_request_approved': 'وافق على طلب تغيير مستوى',
    'platform.action.workspace.tier_request_rejected': 'رفض طلب تغيير مستوى',
    'platform.action.workspace.module_disabled': 'أوقف مديولاً',
    'platform.action.module.default_changed': 'غيّر ظهور مديول للمساحات الجديدة',
    'platform.action.feedback.status_changed': 'غيّر حالة بلاغ',
    'platform.action.feedback.github_issue': 'فتح قضية على جيت هاب',
    'platform.action.feedback.pm_task': 'فتح قضية على مدير المشاريع',
    'platform.action.feedback.pm_policy_changed': 'تغيير طريقة نقل البلاغات إلى مدير المشاريع',
    'platform.action.secret.set': 'ضبط سراً',
    'platform.action.secret.tested': 'اختبر سراً',
    'platform.action.secret.withdrawn': 'سحب سراً',
    'console.secret.name.LLM_API_KEY': 'مفتاح النموذج اللغوي',
    'console.secret.name.LLM_PROVIDER': 'مزوّد النموذج اللغوي',
    'console.secret.name.LLM_MODEL': 'النموذج اللغوي',
    'console.secret.name.LLM_BASE_URL': 'عنوان المزوّد',
    'console.secret.name.NOTIFY_EMAIL_PROVIDER': 'البريد الافتراضي: طريقة الإرسال',
    'console.secret.name.NOTIFY_SMTP_HOST': 'البريد الافتراضي (SMTP): الخادم',
    'console.secret.name.NOTIFY_SMTP_PORT': 'البريد الافتراضي (SMTP): المنفذ',
    'console.secret.name.NOTIFY_SMTP_USER': 'البريد الافتراضي (SMTP): المستخدم',
    'console.secret.name.NOTIFY_SMTP_PASSWORD': 'البريد الافتراضي (SMTP): كلمة المرور',
    'console.secret.name.NOTIFY_EMAIL_FROM': 'البريد الافتراضي: المرسِل',
    'console.secret.name.NOTIFY_EMAIL_HTTP_URL': 'البريد الافتراضي (HTTP): العنوان',
    'console.secret.name.NOTIFY_EMAIL_HTTP_TOKEN': 'البريد الافتراضي (HTTP): المفتاح',
    'console.secret.name.NOTIFY_WHATSAPP_PROVIDER': 'واتساب المنصة: المزوّد',
    'console.secret.name.NOTIFY_WHATSAPP_PHONE_NUMBER_ID': 'واتساب المنصة: الرقم',
    'console.secret.name.NOTIFY_WHATSAPP_ACCESS_TOKEN': 'واتساب المنصة: مفتاح الوصول',
    'console.secret.name.NOTIFY_WHATSAPP_APP_SECRET': 'واتساب المنصة: سر التطبيق',
    'console.secret.name.NOTIFY_WHATSAPP_VERIFY_TOKEN': 'واتساب المنصة: مفتاح التحقق',
    'console.secret.name.NOTIFY_SMS_PROVIDER': 'الرسائل النصية الافتراضية: المزوّد',
    'console.secret.name.NOTIFY_SMS_TOKEN': 'الرسائل النصية الافتراضية: المفتاح',
    'console.secret.name.NOTIFY_SMS_SENDER': 'الرسائل النصية الافتراضية: المرسِل',
    'console.secret.name.NOTIFY_PUSH_PROVIDER': 'إشعارات تطبيق الموظفين: المزوّد',
    'console.secret.name.NOTIFY_PUSH_FCM_PROJECT_ID': 'إشعارات تطبيق الموظفين: مشروع Firebase',
    'console.secret.name.NOTIFY_PUSH_FCM_CLIENT_EMAIL': 'إشعارات تطبيق الموظفين: حساب الخدمة',
    'console.secret.name.NOTIFY_PUSH_FCM_PRIVATE_KEY': 'إشعارات تطبيق الموظفين: مفتاح حساب الخدمة',
    'console.secret.name.FEEDBACK_OPERATOR_EMAIL': 'بريد فريق المنتج',
    'console.secret.name.GITHUB_TOKEN': 'مفتاح جيت هاب',
    'console.secret.name.GITHUB_REPO': 'مستودع جيت هاب',
    'console.secret.name.PM_URL': 'عنوان مدير المشاريع (pm)',
    'console.secret.name.PM_TOKEN': 'مفتاح مدير المشاريع (pm)',
};
//# sourceMappingURL=i18n-console.js.map